import React from 'react';
import LegalPage from './LegalPage';
import { TERMS_SECTIONS, LAST_UPDATED } from './legalContent';

const Terms: React.FC = () => (
  <LegalPage
    title="Terms of Service"
    lastUpdated={LAST_UPDATED}
    intro={
      'The agreement for using TopoSDS. Written to be read: what the service is, what we are '
      + 'responsible for, what you are responsible for, and how either side ends it.'
    }
    sections={TERMS_SECTIONS}
  />
);

export default Terms;
